import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { brandExcelHeaders } from '../../shared/models/mock-data';
 
@Component({
  selector: 'app-reward-products',
  templateUrl: './reward-products.component.html',
  styleUrls: ['./reward-products.component.scss']
})
export class RewardProductsComponent implements OnInit {
 
 
 
reward_details:any={
  reward_products:[],
  product_types: [],
};
  tempOptionModel: any;
  rewardProductHeaders: any;
  reward_product_fields:any;
 
  rewardsexcelDetails:any = {category:[],subCategory:[],brands:[],price_type:[],product_types:[]};
  excelFileName: any;
  filteredDetails: any = {
    search_string:'',
    category: [],
    brands:[],
    sku: '',
  };
  filteredDetailsForApi:any = {
    search_string:'',
    category: '',
    brands:'',
    sku: '',
  };
  getPaginationCount = 0;
  page = 1;
 
  data_list: any = {
     reward_window_close_message: ''
  };
  reward_flag:any
  cash_flag:any
  toggle_status:any
  module:any;
 
constructor(private router :Router,
  private apiService: ApiService,
  private apiConfig: ApiConfiguration,
  private modalService: NgbModal,
  public toast: ToastClientService,
  private xlsx: XlsxService,
  public exportExcelService: ExportExcelService,
  private uploadFile:UploadZipService,
  private cdr: ChangeDetectorRef
  ) { }
 
ngOnInit() {
  this.getAllRewards();
  this.getProductsList(this.filteredDetailsForApi);
    this.getRewardDisableStatus();
}
 
 
getAllRewards() {
  this.apiService.get(this.apiConfig.getRewardProducts).subscribe(
    (res: any) => {
      this.reward_details = res.data;
      if(this.reward_details){
        this.rewardsexcelDetails.category = this.reward_details.reward_categories;
        this.rewardsexcelDetails.subCategory = this.reward_details.reward_sub_categories;
        this.rewardsexcelDetails.brands = this.reward_details.reward_brands;
        this.rewardsexcelDetails.product_types = this.reward_details.product_types;
        this.rewardsexcelDetails.price_type = this.reward_details.price_type;
        let headers = Object.keys(this.reward_details.reward_product_fields);
        this.reward_product_fields = headers;
      }
 
    },
    (err) => {
      console.log(err);
    }
  );
}
 
getProductType(tid)
{
  return this.reward_details.product_types.find(t=>t.id==tid).product_type;
}
 
 
createReward()
{
  this.router.navigateByUrl('/hubAdmin/create-reward-product');
}
 
/**
   * @auth kailash_dev
   */
  /** Add new brands section */
  showuploadTemplateModal(targetModal){
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel(){
    this.tempOptionModel.close();
  }
  downloadFile() {
    this.exportExcelService.exportRewardsExcel(this.reward_product_fields,'Add_rewards_',this.rewardsexcelDetails);
  }
  uploadXlsx(eve){
    if(eve.target.files){
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then(res => {
      this.xlsxView(res);
    });
  }
  xlsxView(data){
    this.closeoptionModel();
    let modalRef =this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true,
      windowClass : "ExcelTemplateViewModal"
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then((result) => {
      if(result){
        this.uploadMultiData(result);
      }
    }, (reason) => {
    });
  }
  // uploadMultiData(data){
  //   let sendData = {
  //     program_id:1,
  //     reward_products:data
  //   }
  //   this.apiService.post(this.apiConfig.uploadMultiRewards, sendData)
  //     .subscribe((res:any)=>{
  //       this.toast.Success('Brands added successfully!');
  //       this.getAllRewards();
  //     },err=>{
  //       console.log('err', err);
  //     })
  // }
  uploadMultiData(data){
    this.enableUploadDiv(data);
  }
  enableUploadDiv(data){
    this.uploadFile.changeMessage({status:'upload',data:data,url:this.apiConfig.uploadMultiRewards,module:'Rewards',excelname:this.excelFileName});
  }
  deleteBrand(){
 
  }
  /* Fillter section start */
  async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // category
        this.filteredDetails.category = await this.formateFillters( data,"category");
        break
      case 2: // brands
        this.filteredDetails.brands = await this.formateFillters( data,"brands");
        break
      default:
        break;
    }
  }
  formateFillters(data, name) {
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1);
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach((element) => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }
  filterListOfRecords(){
    try {
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
      this.filteredDetailsForApi.sku = this.filteredDetails.sku;
      this.filteredDetailsForApi.category = [...this.filteredDetails.category].toString();
      this.filteredDetailsForApi.brands = [...this.filteredDetails.brands].toString();
    } catch (error) {    }
    console.log('filteredDetailsForApi::',this.filteredDetailsForApi);
    this.getProductsList(this.filteredDetailsForApi);
  }
  paginationClick(pageNumber) {
    this.page = pageNumber;
    this.getProductsList(this.filteredDetailsForApi);
  }
  getProductsList(data){
    this.apiService.getHeaders(this.apiConfig.getReardProductsWithPagination+"&page="+this.page+'&prod_name='+data.search_string+'&sku='+data.sku+'&reward_category_id='+
    data.category+'&reward_brand_id='+data.brands)
    .subscribe((res:any)=>{
      this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
      this.reward_details.reward_products = res.body.data;
    })
  }
 
 
   // rewards window
 
  rewardWindow(modal){
    this.modalService.open(modal, { centered: true, backdrop: true, size: 'lg' })
  }
 
  getRewardDisableStatus(){
    this.apiService.get(this.apiConfig.getDisableStatus)
    .subscribe((res:any)=>{
      this.data_list =res.data.reward_window_configuration[0]
      this.reward_flag = this.data_list.gift_card_rewards
      this.cash_flag = this.data_list.cashback_rewards
    
    })
  }
 
  disabledToggle(targetModal,data,e){
     this.modalService.open(targetModal, {
        centered: true,
        backdrop: "static",
        size: 'md'
      });
    this.toggle_status = e.target.checked
    this.module = data
  }
 
 
  update(module,event: Event, modal: NgbModalRef){
    event.preventDefault(); // prevent default behavior if button is inside a form
    console.log('Modal closed and reset');
    modal.close();
    if (module === 'reward') {
      this.reward_flag = this.toggle_status ? 1 : 0;
    } else if (module === 'cash') {
      this.cash_flag = this.toggle_status ? 1 : 0;
    }
  }
 
  closeAndResetModal(module,event: Event, modal: NgbModalRef) {
    this.getRewardDisableStatus();
      if(module =='reward'){
       this.reward_flag = this.data_list.gift_card_rewards;
    }else if(module == 'cash'){
      this.cash_flag = this.data_list.cashback_rewards
    }
     this.cdr.detectChanges();
    event.preventDefault(); // prevent default behavior if button is inside a form
    modal.close(); // closes only this modal
  }
 
  update_status(){
    if(!this.data_list.reward_window_close_message){
      return this.toast.Error('Please enter the message')
    }
 
    let payload ={
      gift_card_rewards: this.reward_flag ? 1 : 0,
      cashback_rewards: this.cash_flag ? 1 : 0,
      reward_window_close_message: this.data_list.reward_window_close_message
    }
    console
    this.apiService.post(this.apiConfig.updateRewardsStatus,payload)
    .subscribe((res:any)=>{
      console.log(res)
      this.toast.Success(res.body.data.message)
      this.modalService.dismissAll();
    })
  }
 
  closeModal() {
    this.modalService.dismissAll()
  }
}